import {Component, input} from '@angular/core';
import {FieldInputType} from '@vasio-nl/valow';

@Component({
  selector: 'app-location-space-for-siblings-column',
  standalone: true,
  imports: [],
  templateUrl: './location-space-for-siblings-column.component.html',
  styleUrl: './location-space-for-siblings-column.component.scss',
})
export class LocationSpaceForSiblingsColumnComponent {
  value = input<string>();
  rowData = input<any>();
  field = input.required<FieldInputType>();
}
